if (!customElements.get('product-info')) {
  class ProductInfo extends HTMLElement {
    abortController = undefined;

    constructor() {
      super();
    }

    handleHiddenVariantLanding() {
      const isHidden = this.getAttribute('data-selected-variant-hidden') === 'true' || this.dataset.selectedVariantHidden === 'true';
      if (!isHidden) return;

      if (!window.location.pathname.includes('/products/')) return;
      if (!this.dataset.url) return;

      const enforceCleanUrl = () => {
        const url = new URL(window.location.href);
        const shouldCleanUrl = url.searchParams.has('variant') || url.searchParams.has('selling_plan');
        if (!shouldCleanUrl) return;

        const cleanUrl = `${this.dataset.url}${window.location.hash || ''}`;
        window.history.replaceState({}, '', cleanUrl);
        window.location.reload();
      };

      enforceCleanUrl();
    }

    setupEventListeners() {
      this.variantSelector?.addEventListener('change', this.onVariantChange.bind(this));
      if(this.quantitySelector){
        this.quantitySelector.addEventListener('change', this.onQuantitySelectorEvent.bind(this));
        this.quantitySelector.querySelector('button[name="plus"]').addEventListener('click', this.onQuantitySelectorEvent.bind(this));
        this.quantitySelector.querySelector('button[name="minus"]').addEventListener('click', this.onQuantitySelectorEvent.bind(this));
      }
      document.addEventListener('liquid-ajax-cart:request-end', this.onCartUpdate.bind(this));

      this.querySelectorAll('.selling-plan-group-radio').forEach(radio => {
        radio.addEventListener('click', this.sellingPlanGroupClick.bind(this));
        radio.closest('.selling_options_container').querySelector('input[data-radio-type="one_time_purchase"]').addEventListener('change', () => {
          radio.dataset.selected = false;
        });
      });

      // Selling plan selection
      this.querySelectorAll('label input[data-radio-type="selling_plan"]').forEach(input => {
        input.addEventListener('change', this.sellingPlanGroupChange.bind(this));
        input.addEventListener('click', this.sellingPlanGroupChange.bind(this));
      });

      // Selling plan dropdown opener
      this.querySelectorAll('.selling-plan-group-opener').forEach(opener => {
        opener.addEventListener('click', this.sellingPlanGroupOpenerClick.bind(this));
      });

      // Custom quantity dropdown
      this.querySelector('.custom-quanity-dropdown-opener')?.addEventListener('click', this.customQuantityDropdownOpenerClick.bind(this));

      // Custom quantity selection
      this.querySelectorAll('.custom-quanity-dropdown-list li').forEach(li => {
        li.addEventListener('click', this.customQuantityDropdownSelection.bind(this));
      });

      // Shipping info modal
      this.querySelector('.shipping-info-button').addEventListener('click', this.shippingInfoModalOpenerClick.bind(this));
      document.querySelector('.shipping-info-modal-close').addEventListener('click', () => {
        const modal = document.querySelector('.shipping-info-modal');
        const modalContent = document.querySelector('.shipping-info-modal-content');
        modalContent.classList.remove('active');
        modal.classList.remove('active');
      });

      // Close shipping info modal on outside click
      document.addEventListener('click', function(event) {
        const myElement = document.querySelector('.shipping-info-modal-content');
        const modalOpener = document.querySelector('.shipping-info-button');
        if (event.target !== myElement && !myElement.contains(event.target) && event.target !== modalOpener) {
          const modal = document.querySelector('.shipping-info-modal');
          const modalContent = document.querySelector('.shipping-info-modal-content');
          modalContent.classList.remove('active');
          modal.classList.remove('active');
        }
      });

      // Close selling plan dropdown on outside click
      document.addEventListener('click', function(event) {
        const sellingPlanDropdown = this.querySelector('.selling-plan-group-options-list.active');
        if (!sellingPlanDropdown) return;
        const sellingPlanDropdownOpener = sellingPlanDropdown.parentElement.querySelector('.selling-plan-group-opener');
        if (event.target !== sellingPlanDropdown && !sellingPlanDropdown.contains(event.target) && event.target !== sellingPlanDropdownOpener) {
          sellingPlanDropdown.classList.remove('active');
        }
      });

      // Close quantity dropdown on outside click
      document.addEventListener('click', function(event) {
        const quantityDropdown = this.querySelector('.custom-quanity-dropdown-list.active');
        if (!quantityDropdown) return;
        const quantityDropdownOpener = quantityDropdown.parentElement?.querySelector('.custom-quanity-dropdown-opener');
        if (event.target !== quantityDropdown && !quantityDropdown.contains(event.target) && event.target !== quantityDropdownOpener) {
          quantityDropdown.classList.remove('active');
        }
      });

    }

    connectedCallback() {
      this.handleHiddenVariantLanding();
      this.setupEventListeners();
    }

    onCartUpdate(e) {
      if (!window.location.pathname.includes('/products/')) return;
      const { requestState } = e.detail;
      // If the "add to cart" request is successful
      if (requestState.requestType === 'add' && requestState.responseData?.ok) {
        // Add the CSS class to the "body" tag
        /* const productData = document.querySelector("[data-product]")?.innerHTML;
        const parsedProductData = JSON.parse(productData);
        const variantData = document.querySelector("[data-selected-variant]")?.innerHTML;
        const parsedVariantData = JSON.parse(variantData);
        const subscriptionElement = document.querySelector('og-optin-button[frequency]');
        let sellingPlanId = null;
        if(this.hasAttribute('data-bundle-product')){
          const sellingPlanInput = document.querySelector(".selected-selling-plan-id");
          sellingPlanId = sellingPlanInput.value ? sellingPlanInput.value : null;
        }else{
         sellingPlanId = subscriptionElement?.hasAttribute('subscribed')? subscriptionElement.getAttribute('frequency') : null;
        }
        // Product data
        const item = {
          item_id: parsedVariantData.sku,
          item_name: parsedProductData.title,
          item_variant: parsedVariantData.title,
          price: parsedVariantData.price/100,
          quantity: parseInt(this.querySelector(`#Quantity-${this.dataset.section}`).value),
          item_brand: parsedProductData.vendor,
          item_category: parsedProductData.type,
          selling_plan_id: sellingPlanId
        };
        dataLayer.push({
          event: "add_to_cart",
          ecommerce: {
            currency: Shopify.currency.active,
            value: (parsedVariantData.price/100) * item.quantity,
            items: [item]
          }
        }); */

        document.body.classList.add('js-show-ajax-cart');
        // dispatch a custom event
        document.dispatchEvent(
          new CustomEvent('item-added-to-cart', {
            detail: requestState?.responseData?.body,
          })
        );
      }
      
    }

    get variantSelector() {
      return this.querySelector('variant-selector');
    }

    get quantitySelector() {
      return this.querySelector('quantity-selector');
    }

    get selectedOptionValues() {
      if (this.variantSelector.dataset.pickerType === 'dropdown') {
        const list = Array.from(this.variantSelector.querySelectorAll('select')).map(
          (select) => select.options[select.selectedIndex].dataset.optionValueId
        );
        return list;
      } else {
        const list = Array.from(this.variantSelector.querySelectorAll('fieldset input:checked')).map(
          ({ dataset }) => dataset.optionValueId
        );
        return list;
      }
    }

    getSelectedVariant(html) {
      const selectedVariant = html.querySelector('[data-selected-variant]')?.innerHTML;
      return !!selectedVariant ? JSON.parse(selectedVariant) : null;
    }

    onVariantChange(e) {
      const hasDifferentProductUrl = e.target?.dataset?.productUrl ? (e.target?.dataset?.productUrl !== this.dataset.url) : false;
      const productUrl = e.target?.dataset?.productUrl || this.dataset.url;
      this.renderSection(hasDifferentProductUrl, productUrl);
      
      // Update bulk quantity total if bulk selector exists
      this.updateBulkQuantityTotal();

      // Track product option selection
      const optionName = e.target.name || '';
      const optionValue = e.target.value || '';
      
      if (optionName && optionValue) {
        let optionType = 'unknown';
        const downcasedName = optionName.toLowerCase();
        
        if (downcasedName.includes('flavor')) {
          optionType = 'flavor';
        } else if (downcasedName.includes('size')) {
          optionType = 'size';
        } else if (downcasedName.includes('quantity')) {
          optionType = 'quantity';
        }
        
        if (window.trackProductOptionSelected) {
          window.trackProductOptionSelected(optionType, optionValue, this.dataset.productId, this.dataset.productName);
        }
      }
    }

    onQuantitySelectorEvent(e) {
      const quantityInput = this.quantitySelector.querySelector('input[type="number"]');
      let currentValue = parseInt(quantityInput.value);
      const minValue = parseInt(quantityInput.getAttribute('min')) || 0;
      const maxValue = parseInt(quantityInput.getAttribute('max')) || Infinity;

      if (e.target.name === 'minus' && currentValue > minValue) {
        quantityInput.value = currentValue - 1;
      } else if (e.target.name === 'plus' && currentValue < maxValue) {
        quantityInput.value = currentValue + 1;
      } else if (e.type === 'change') {
        if (currentValue < minValue) {
          quantityInput.value = minValue;
        } else if (currentValue > maxValue) {
          quantityInput.value = maxValue;
        }
      }

      // Update the Add to Cart button total price
      const addToCartTotal = this.querySelector(`#add-to-cart-container-${this.dataset.section} .add-to-cart-total`);
      const variantDataScript = this.querySelector('script[data-selected-variant]');
      let variant = null;
      if (variantDataScript) {
        try {
          variant = JSON.parse(variantDataScript.textContent);
        } catch (err) {}
      }
      const qty = parseInt(quantityInput.value) || 1;
      if (addToCartTotal && variant && typeof variant.price === 'number') {
        const total = variant.price * qty;
        if (window.Shopify && Shopify.formatMoney) {
          addToCartTotal.textContent = `${Shopify.formatMoney(total, Shopify.money_format)}`;
        } else {
          addToCartTotal.textContent = `$${(total / 100).toFixed(2)}`;
        }
      }
    }


    sendUpdateMediaEvent() {
      const myCustomEvent = new CustomEvent('update:media', {
        bubbles: true,
        cancelable: true
      });
      this.dispatchEvent(myCustomEvent);
    }

    updateAffirmMessage(html,id){
      const source = html.getElementById(`${id}`);
      const destination = this.querySelector(`#${id}`);
      if (source && destination) {
        destination.innerHTML = source.innerHTML;
      }
      if (window.affirm && window.affirm.ui) {
        window.affirm.ui.refresh()
      }
    }

    updateBulkQuantityTotal() {
      const bulkSelector = this.querySelector('bulk-product-atc');
      if (!bulkSelector) return;

      const bulkInputs = bulkSelector.querySelectorAll('.bulk-quantity-input');
      const addToCartTotal = this.querySelector(`#add-to-cart-container-${this.dataset.section} .add-to-cart-total`);
      
      if (!addToCartTotal || !bulkInputs.length) return;

      let totalQuantity = 0;
      let totalPrice = 0;

      bulkInputs.forEach(input => {
        const quantity = parseInt(input.value) || 0;
        const variantId = input.closest('.bulk-quantity-row').dataset.variantId;
        const variantPrice = parseInt(input.closest('.bulk-quantity-row').dataset.price) || 0;
        
        totalQuantity += quantity;
        totalPrice += quantity * variantPrice;
      });

      // If no quantities are selected, show 0
      if (totalQuantity === 0) {
        addToCartTotal.textContent = '$0.00';
      } else if (window.Shopify && Shopify.formatMoney) {
        addToCartTotal.textContent = `${Shopify.formatMoney(totalPrice, Shopify.money_format)}`;
      } else {
        addToCartTotal.textContent = `$${(totalPrice / 100).toFixed(2)}`;
      }
    }

    updateURL(variantId) {
      if (window.location.pathname.includes('/products/')) {
        window.history.replaceState({}, '', `${this.dataset.url}${variantId ? `?variant=${variantId}` : ''}`);
        return;
      }

      try {
        const url = new URL(window.location.href);
        if (variantId) {
          url.searchParams.set('variant', String(variantId));
        } else {
          url.searchParams.delete('variant');
        }
        window.history.replaceState({}, '', `${url.pathname}${url.search}${url.hash}`);
      } catch (e) {
        console.error(e);
      }
    }

    updateSourceFromDestination = (html, id) => {
      const source = html.getElementById(`${id}`);
      const destination = this.querySelector(`#${id}`);
      if (source && destination) {
        destination.innerHTML = source.innerHTML;
      }
    };

    updateProductMediaGallery = (html, id,variant) => {
      const source = html.getElementById(`${id}`);
      const destination = this.querySelector(`#${id}`); 
      if (!source || !destination || !variant) return;
      
      const sourceWrappers = source.querySelectorAll('.swiper-wrapper');
      const destWrappers = destination.querySelectorAll('.swiper-wrapper');
      
      destWrappers.forEach((destWrapper, index) => {
        const sourceWrapper = sourceWrappers[index];
        if (!sourceWrapper) {
          console.warn(`Missing source wrapper at index ${index}`);
          return;
        }
        destWrapper.innerHTML = sourceWrapper.innerHTML;
      });
      this.sendUpdateMediaEvent();
    }

    updateMainProductButtonUrl = (html, id) => {
      const source = html.querySelector(`#${id}`);
      const destination = this.querySelector(`#${id}`);
      if (!source || !destination) return;

      const is_it_variant_specific_url = destination.getAttribute('data-is-variant-specific-url') === 'true';
      if (!is_it_variant_specific_url) return;

      const sourceLink = source.querySelector('a.main-product-navigation-button');
      const destinationLink = destination.querySelector('a.main-product-navigation-button');
      if (!destinationLink) return;

      const nextHref = sourceLink?.getAttribute('href')?.trim() || '';
      destinationLink.setAttribute('disabled', '');
      requestAnimationFrame(() => {
        if (nextHref) {
          destinationLink.setAttribute('href', nextHref);
          destinationLink.removeAttribute('disabled');
        } else {
          destinationLink.removeAttribute('href');
          destinationLink.setAttribute('disabled', '');
        }
      });
    };


    updateCompareAtPrice = (html, id) => {
      const sourceCompareAtPrice = html.getElementById(`${id}`);
      const destinationCompareAtPrice = this.querySelector(`#${id}`);
      const ogOfferCompareAtPriceEle = destinationCompareAtPrice?.querySelector(".main-product-sub-compare-at-price");
      if (destinationCompareAtPrice && sourceCompareAtPrice) {
        const UpdatedPrice = sourceCompareAtPrice.getAttribute("data-compare-at-price");
        if (UpdatedPrice) {
          destinationCompareAtPrice.setAttribute("data-compare-at-price", `${UpdatedPrice}`);
        }
        if (ogOfferCompareAtPriceEle && UpdatedPrice){
           ogOfferCompareAtPriceEle.innerHTML = UpdatedPrice;
        }
      }
    }

    updateVariantInputs(variantId) {
      this.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`).forEach(
        (productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = variantId ?? '';
          input.dispatchEvent(new Event('input', { bubbles: true }));
        }
      );
    }

    autoSelectFirstAvailableRadios() {
      // For each fieldset in your variant section, select the first enabled radio if none checked
      this.querySelectorAll('.product-form__input').forEach((fieldset) => {
        const radios = Array.from(fieldset.querySelectorAll('input[type="radio"]:not(.disabled)'));
        if (!radios.length) return;
        if (!radios.some(radio => radio.checked)) {
          radios[0].checked = true;
          radios[0].dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }

    renderSection(hasDifferentProductUrl, productUrl) {
      this.abortController?.abort();
      this.abortController = new AbortController();

      fetch(`${productUrl}?option_values=${this.selectedOptionValues}&section_id=${this.dataset.section}`, {
        signal: this.abortController.signal,
      })
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const variant = this.getSelectedVariant(html);
          if (hasDifferentProductUrl) {
            const productInfo = html.querySelector('product-info');
            this.replaceWith(productInfo);
            if (!productInfo.querySelector('skio-plan-picker')) {
              productInfo.updateURL(variant?.id);
            }
          } else {
            this.updateProductMediaGallery(html, `product-media-gallery-${this.dataset.section}`, variant);
            if (!this.querySelector('skio-plan-picker')) {
              this.updateURL(variant?.id);
            }
            this.updateVariantInputs(variant?.id);
            this.updateSourceFromDestination(html, `add-to-cart-container-${this.dataset.section}`);
            // Update the Add to Cart button price dynamically
            const addToCartTotal = this.querySelector(`#add-to-cart-container-${this.dataset.section} .add-to-cart-total`);
            if (addToCartTotal && variant && typeof variant.price === 'number') {
              if (window.Shopify && Shopify.formatMoney) {
                addToCartTotal.textContent = `${Shopify.formatMoney(variant.price, Shopify.money_format)}`;
              } else {
                // fallback if Shopify.formatMoney is not available
                addToCartTotal.textContent = `$${(variant.price / 100).toFixed(2)}`;
              }
            }
            this.updateSourceFromDestination(html, `variant-selector-${this.dataset.section}`);
            this.updateSourceFromDestination(html, `price-${this.dataset.section}`);
            this.updateSourceFromDestination(html, `sku-${this.dataset.section}`);
            this.updateSourceFromDestination(html, `inventory-${this.dataset.section}`);
            this.updateSourceFromDestination(html, `main-product-sets-size-desktop-${this.dataset.section}`);
            this.updateSourceFromDestination(html, `main-product-sets-size-mobile-${this.dataset.section}`);
            this.updateSourceFromDestination(html, `variant-title-desktop-${this.dataset.section}`);
            this.updateSourceFromDestination(html, `variant-title-mobile-${this.dataset.section}`);
            this.updateSourceFromDestination(html, `subscription-${this.dataset.section}`);
            this.updateMainProductButtonUrl(html, `main-product-button-wrapper-${this.dataset.section}`);
            this.autoSelectFirstAvailableRadios();
            this.updateCompareAtPrice(html, `groove-subscription-${this.dataset.section}`);
            // Update bulk quantity total after section update
            this.updateBulkQuantityTotal();
          }
          
          // Dispatch event to signal that renderSection is complete
          document.dispatchEvent(new CustomEvent('renderSection:complete', {
            detail: { sectionId: this.dataset.section, variant: variant,html:html }
          }));
          
          this.updateAffirmMessage(html,`affirm-${this.dataset.section}`);
        })
        .catch((error) => {
          if (error.name === 'AbortError') {
            console.log('Fetch aborted by user');
          } else {
            console.error(error);
          }
        });
    }

    // Selling plan customizations
    sellingPlanGroupClick(e) {
      const sellingPlanId = e.currentTarget.dataset.selectedSellingPlanId;
      const parentDiv = e.currentTarget.closest('.selling-plan-group-container');
      const sellingPlanInput = parentDiv.querySelector(`input[data-selling-plan-id="${sellingPlanId}"]`);
      e.currentTarget.dataset.selected = true;

      if(sellingPlanInput){
        sellingPlanInput.click();
      }
    }
    sellingPlanGroupOpenerClick(e) {
      const parentDiv = e.currentTarget.parentElement;
      const dropdown = parentDiv.querySelector('.selling-plan-group-options-list');
      dropdown.classList.add('active');
    }
    sellingPlanGroupChange(e) {
      e.currentTarget.closest('.selling-plan-group-options-list').classList.remove('active');
      e.currentTarget.closest('.selling-plan-custom-dropdown').querySelector('.currently-selected-plan-name').textContent = e.currentTarget.dataset.sellingPlanName;
      
      // Track purchase type selection
      const isSubscription = e.target.value && e.target.value !== '';
      const purchaseType = isSubscription ? 'subscription' : 'one-time';
      
      if (window.trackProductOptionSelected) {
        window.trackProductOptionSelected('purchase_type', purchaseType, this.dataset.productId, this.dataset.productName);
      }
    }

    // Custom quantity dropdown
    customQuantityDropdownOpenerClick(e) {
      const dropdown = e.currentTarget.closest('.custom-quanity-dropdown').querySelector('.custom-quanity-dropdown-list');
      dropdown.classList.add('active');
    }
    customQuantityDropdownSelection(e) {
      const dropdown = e.currentTarget.closest('.custom-quanity-dropdown').querySelector('.custom-quanity-dropdown-list');
      const newQuantity = e.currentTarget.dataset.value;
      
      this.querySelector('input[name="quantity"]').value = newQuantity;
      this.querySelector('.custom-quanity-selected-value').textContent = newQuantity;
      dropdown.classList.remove('active');

      // Track quantity selection
      if (window.trackProductOptionSelected) {
        window.trackProductOptionSelected('quantity', newQuantity, this.dataset.productId, this.dataset.productName);
      }
    }

    // Shipping info modal
    shippingInfoModalOpenerClick() {
      const modal = document.querySelector('.shipping-info-modal');
      const modalContent = document.querySelector('.shipping-info-modal-content');
      modalContent.classList.add('active');
      modal.classList.add('active');
    }
  }

  customElements.define('product-info', ProductInfo);
}